import { BadRequest } from '@tsed/exceptions';
import type { GetServerSideProps, InferGetServerSidePropsType } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { getSelectorsByUserAgent } from 'react-device-detect';
import type { Banner, DefaultCmsDataResponse } from '@/api/cms/types';
import { customerConfig } from '@/modules/customer/customerConfig';
import { MerchantPage } from '@/modules/customer/merchant/MerchantPage';

type Props = {
  // Declare Merchant props
  isSsrMobile: boolean;
  homeBannerData?: DefaultCmsDataResponse<Banner>;
};

export default function Merchant(
  _props: InferGetServerSidePropsType<typeof getServerSideProps> & {
    homeBannerData?: DefaultCmsDataResponse<Banner>;
  }
) {
  return <MerchantPage homeBannerData={_props.homeBannerData} />;
}

export const getServerSideProps: GetServerSideProps<Props> = async (
  context
) => {
  const { locale } = context;
  if (locale == undefined) {
    throw new BadRequest('locale is missing');
  }
  const { i18nNamespaces } = customerConfig;

  const { isMobile: isSsrMobile } = getSelectorsByUserAgent(
    context.req.headers['user-agent'] as string
  );

  return {
    props: {
      ...(await serverSideTranslations(locale, i18nNamespaces)),
      isSsrMobile,
    },
  };
};
